import React, { ReactNode } from 'react';
import { SpeciesData } from './dex-species';
import {
  addAllBaseStats,
  beautifyPokemonName,
  TYPES_TO_COLORS,
} from './index';

export type TableHeader = {
  name: string,
  value: (stats: SpeciesData) => number | string | null,
  render?: (stats: SpeciesData) => ReactNode,
};

export const TABLE_HEADERS: TableHeader[] = [
  { name: '#', value: (stats: SpeciesData): number => stats.num },
  {
    name: 'Name',
    value: (stats: SpeciesData): string => beautifyPokemonName(stats.name),
  },
  {
    name: 'Type 1',
    value: (stats: SpeciesData): string => stats.types[0],
    render: (stats: SpeciesData) => {
      const [type1] = stats.types;
      return (
        <td className="whitespace-nowrap font-bold text-gray-600 text-xs px-1 py-1.5">
          <span style={{ color: `rgb(${TYPES_TO_COLORS[type1].join(',')})` }}>{type1}</span>
        </td>
      );
    },
  },
  {
    name: 'Type 2',
    value: (stats: SpeciesData): string | null => {
      if (stats.types[1] === undefined) return null;
      return stats.types[1];
    },
    render: (stats: SpeciesData) => {
      const [, type2] = stats.types;
      if (type2 === undefined) return <td>{null}</td>;
      return (
        <td className="whitespace-nowrap font-bold text-gray-600 text-xs px-1 py-1.5">
          <span style={{ color: `rgb(${TYPES_TO_COLORS[type2].join(',')})` }}>{type2}</span>
        </td>
      );
    },
  },
  { name: 'HP', value: (stats: SpeciesData): number => stats.baseStats.hp },
  { name: 'Atk', value: (stats: SpeciesData): number => stats.baseStats.atk },
  { name: 'Def', value: (stats: SpeciesData): number => stats.baseStats.def },
  { name: 'SpA', value: (stats: SpeciesData): number => stats.baseStats.spa },
  { name: 'SpD', value: (stats: SpeciesData): number => stats.baseStats.spd },
  { name: 'Spe', value: (stats: SpeciesData): number => stats.baseStats.spe },
  { name: 'BST', value: (stats: SpeciesData): number => addAllBaseStats(stats.baseStats) },
];

export const TABLE_HEADERS_COMPACT: TableHeader[] = TABLE_HEADERS.slice(0, 4);
